import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export default function GoogleCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const code = params.get("code");
    const oauthError = params.get("error");
    if (oauthError || !code) {
      toast.error("Google sign-in was cancelled.");
      navigate("/login", { replace: true });
      return;
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google";
    api
      .post("/auth/google", { code, redirect_uri: redirectUri })
      .then((response) => {
        signIn(response.data);
        toast.success("Welcome to COIGuardian.");
        navigate("/dashboard", { replace: true });
      })
      .catch((requestError) => {
        const message = formatApiError(requestError);
        setError(message);
        toast.error(message);
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-slate-50 px-6 text-center text-sm text-slate-500" data-testid="google-callback-page">
      <div>{error || "Completing your Google sign-in…"}</div>
    </main>
  );
}
